import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import './Index.css';

//Components
import SubMenu from '../SubMenu/Index';
import Recents from '../Recents/Index';
import MenuItem from './MenuItem';
import UserMenu from '../UserMenu';

import logoImg from '../../../assets/images/logo-heyho-branco.svg';
import CloudImg from '../../../assets/images/cloud';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { MenuState } from '../../../store/reducers/menuReducer';
import { UserState } from '../../../store/reducers/userReducer';
import { PrefState } from '../../../store/reducers/prefReducer';
import { RootState } from '../../../store/index';
import LcIconLink from '../../Generic/LcIconLink';
import { authProvider } from '../../../services/authProvider';
import DashboardService from '../../../services/DashboardService/DashboardService';

export interface GraphUser {
    Name: string,
    Email: string,
    Photo: string,
    Organization: string
}

interface Props {
    changeShowTutorials: Function
}

const Menu: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const [vendorCredentialsWizardRequired, setVendorCredentialsWizardRequired] = useState<boolean>(true);
    const dashnoardService = new DashboardService(props);
    // useEffect(() => {

    //     if (user && user.VendorStatusList) {

    //         if (user.VendorStatusList.filter(x => x.status == 'Correto').length == user.VendorStatusList.length) {
    //             setVendorCredentialsWizardRequired(true);
    //         }
    //         else {
    //             setVendorCredentialsWizardRequired(false);
    //         }
    //     }
    // }, [user.ClientGroupSelected])

    //#region - Redux Dados do Menu

    useEffect(() => {
        const getListRepost = async () => {
            if (!menu.report) {
                try {
                    let responseList = await dashnoardService.getReportList(Number(user.id));
                    dispatch({ type: 'MENU_REPORT', payload: responseList.data.length > 0 });
                }
                catch (error) {
                    console.debug(error)
                }
            }
        }

        user.id && getListRepost();
    }, [user.id])

    useEffect(() => {
        if (!menu.pinned) {
            dispatch({ type: 'MENU_TOGGLE', payload: true });
        }
    }, [])

    const dispatch = useDispatch();

    const handleHome = (event, path) => {
        if (pref.promptStatus === true) {
            dispatch({ type: 'PREF_PROMPT_SHOW', payload: true });
            dispatch({ type: 'PREF_PROMPT_PATH', payload: path });
            event.preventDefault()
            event.returnValue = ''
            return;
        }
        dispatch({ type: 'MENU_SELECTED_UPDATE', payload: null });
        dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
        // dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: null });
        // localStorage.setItem('HeyHo_LastMenuItem', '');
        window.innerWidth <= 600 &&
            handleToggle(true);
    }

    useEffect(() => {
        if (!menu.pinned) {
            dispatch({ type: 'MENU_TOGGLE', payload: true });
        }
    }, [])

    const handleMenu = (menu: any[]) => {
        dispatch({ type: 'MENU_UPDATE', payload: menu });
    }

    const handleSelectedMenu = (menuItem: object) => {
        dispatch({ type: 'MENU_SELECTED_UPDATE', payload: menuItem });
    }

    //#endregion

    // useEffect(() => {
    //     user.ClientGroupSelected && user.UserId &&
    //         handleMenu(user.Menus as []);
    //     localStorage.setItem("LiveCloud_Menu", JSON.stringify(user.Menus));
    // }, [user.ClientGroupSelected])

    const handleToggle = (open: boolean) => {
        if (!menu.pinned) {
            dispatch({ type: 'MENU_TOGGLE', payload: open });
        }
    }

    const handleShowMenu = (itemId?: string) => {
        if (window.innerWidth < 600) {
            //dispatch({ type: 'MENU_TOGGLE', payload: true });
        }
        const itemSelected = menu.items.find((item: { id: string | undefined; }) => item.id === itemId);
        handleSelectedMenu(itemSelected);
        dispatch({ type: 'MENU_SUB_VISIBLE', payload: (menu.selectedItem && itemId !== menu.selectedItem.id) || !menu.showSubMenu });
    }

    const [screenSize, setScreenSize] = useState<number>();

    const tamanhoTela = () => {
        const tela = document.getElementById("tela");
        setScreenSize(tela?.clientHeight && tela?.clientHeight)
    }

    useEffect(() => {
        tamanhoTela();
    }, [])

    const handlePin = () => {
        dispatch({ type: 'MENU_PINNED', payload: !menu.pinned });
    }

    useEffect(() => {
        if (menu.showHelper) {
            dispatch({ type: 'MENU_PINNED', payload: false });
            dispatch({ type: 'MENU_TOGGLE', payload: true });
        }
    }, [menu.showHelper])

    return (
        <div
            onMouseEnter={() => handleToggle(false)}
            onMouseLeave={() => handleToggle(true)}
            id="tela"
            className={`menu ${menu.toggle ? 'toggled' : ''}`}
            style={{ backgroundColor: menu.prodQaDatabase == true ? "red" : "#141b4d" }}
        >

            <div className="closemenu mobile-only">
                <LcIconLink icon="ppi ppi-x" tooltip="Fechar" onClick={() => { dispatch({ type: 'MENU_TOGGLE', payload: true }) }}></LcIconLink>
            </div>

            {
                menu && menu.showSubMenu &&
                <SubMenu toggle={menu.toggle} />
            }
            {
                menu.showUserMenu &&
                <UserMenu toggle={menu.toggle} />
            }

            {/* <div className="toggler" onClick={() => handleToggle()}>
                <i className={`ppi ppi-chevron-${menu.toggle ? 'right' : 'left'}`}></i>
            </div> */}

            <div className="userinfo link" onClick={() => { /* dispatch({ type: 'MENU_USER_VISIBLE', payload: !menu.showUserMenu });*/ }}>
                <img className="avatar" alt={user.name} src={user.Photo && `data:image/jpeg;base64,${user.Photo}`} />
                {
                    !menu.toggle &&
                    <div className='infosMenu'>
                        <div className="corporate">
                            <div className="user">{user.name}</div>
                            <div className="company">{user.defaultCustomer.name}</div>
                        </div>
                        {
                            window.screen.width > 600 &&
                            <LcIconLink activedAfterClick={menu.pinned} icon={'ppi ppi-pin'} tooltip={(menu.pinned) ? "Desfixar" : "Fixar"} onClick={() => handlePin()} actBgColor={'#1b3a7a'} />
                        }
                    </div>
                }
            </div>
            {
                vendorCredentialsWizardRequired &&
                <>
                    <div className="items">

                        {/* <Link to="/" className="item" onClick={handleHome}>
                            <i className="icon ppi ppi-home" />
                            {!menu.toggle && (<span className="title"> Início </span>)}
                        </Link> */}

                        <NavLink exact to="/"
                            style={(isActive) => ({
                                color: (isActive) ? '#FFB800' : '#898DA6',
                                backgroundColor: (isActive) ? '#1B3A7A' : '#141B4D',
                            })}
                            className="item"
                            onClick={(event) => handleHome(event, "/")}
                        >
                            <i className="icon ppi ppi-user" />
                            <span className="title"> Solicitante </span>
                        </NavLink>
                        <NavLink to="/Attendance"
                            style={(isActive) => ({
                                color: (isActive) ? '#FFB800' : '#898DA6',
                                backgroundColor: (isActive) ? '#1B3A7A' : '#141B4D',
                                display: (user.attendant) ? 'flex' : 'none'
                            })}
                            className="item hideMobile"
                            onClick={(event) => handleHome(event, "/Attendance")}
                        >
                            <i className="icon ppi ppi-chat" />
                            <span className="title"> Atendente </span>
                        </NavLink>

                        <NavLink exact to="/DashBoard"
                            style={(isActive) => ({
                                color: (isActive) ? '#FFB800' : '#898DA6',
                                backgroundColor: (isActive) ? '#1B3A7A' : '#141B4D',
                                display: (user.dashboard) ? 'flex' : 'none'
                            })}
                            className="item hideMobile"
                            onClick={(event) => handleHome(event, "/DashBoard")}
                        >
                            <i className="icon  ppi ppi-chart-square-bar" />
                            {
                                user.attendant &&
                                <span className="title"> Dashboard </span>
                            }
                        </NavLink>
                        <NavLink exact to="/SlaReport"
                            style={(isActive) => ({
                                color: (isActive) ? '#FFB800' : '#898DA6',
                                backgroundColor: (isActive) ? '#1B3A7A' : '#141B4D',
                                display: (menu.report) ? 'flex' : 'none'
                            })}
                            className="item hideMobile"
                            onClick={(event) => handleHome(event, "/SlaReport")}
                        >
                            <i className="icon  ppi ppi-view-grid" />
                            {
                                menu.report &&
                                <span className="title">Gestão à vista</span>
                            }
                        </NavLink>

                        <span className="item" onClick={() => authProvider.LogOutMSSO()} style={{ display: window.screen.width < 600 ? 'flex' : 'none', padding: '1rem' }}>
                            <i className="icon ppi ppi-logout" />
                            {
                                user.attendant && <span className="title"> Sair </span>
                            }
                        </span>

                        {/*    <MenuItem*/}
                        {/*        onClick={() => handleShowMenu('6F96AEFB-3676-4995-9512-A15A6C617E1E')}*/}
                        {/*        icon="ppi ppi-chart-square-bar"*/}
                        {/*        title={'Relatórios'}*/}
                        {/*        selected={menu.selectedItem && menu.selectedItem.id === '6F96AEFB-3676-4995-9512-A15A6C617E1E'} />*/}
                    </div>
                </>
            }
            {
                menu.prodQaDatabase &&
                <span style={{
                    fontSize: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    color: 'lime',
                    paddingTop: '6rem'
                }}> QA EM PROD </span>
            }

            <div className="logo"
                // style={{ marginTop: (screenSize && screenSize < 700 ? "40vh" : "60vh") }}
                style={{ position: "absolute", bottom: "63px", padding: (!menu.toggle) ? "0px 60px" : "0px 4px" }}
            >
                {
                    menu.toggle
                        ? <img alt="HeyHo!" className={`${menu.toggle && 'cloud'}`} src={logoImg}></img>
                        : <img alt="HeyHo!" className={`${menu.toggle && 'cloud'}`} src={logoImg}></img>
                    //<CloudImg/>
                }
            </div>

        </div>
    );
}

export default Menu;